import { createContext, useContext, useState, ReactNode } from 'react';

// Panel types - each panel is self-contained
export type PanelType =
  | 'chat'
  | 'game'
  | 'ship'
  | 'location'
  | 'map'
  | 'cargo'
  | 'missions'
  | 'market'
  | 'npcs'
  | 'repairs'
  | 'history'
  | 'logs'
  | 'db-browser'
  | 'r2-browser'
  | 'database-admin'
  | 'ai-console'
  | 'pinecone-test'
  | 'voice-test';

interface ConsoleContextState {
  // Currently selected panel
  selectedPanel: PanelType;
  setSelectedPanel: (panel: PanelType) => void;
  // Debug mode visibility
  debugMode: boolean;
}

const ConsoleContext = createContext<ConsoleContextState | null>(null);

interface ConsoleProviderProps {
  children: ReactNode;
  debugMode: boolean;
}

export function ConsoleProvider({ children, debugMode }: ConsoleProviderProps) {
  const [selectedPanel, setSelectedPanel] = useState<PanelType>('chat');

  const value: ConsoleContextState = {
    selectedPanel,
    setSelectedPanel,
    debugMode,
  };

  return (
    <ConsoleContext.Provider value={value}>{children}</ConsoleContext.Provider>
  );
}

export function useConsole() {
  const context = useContext(ConsoleContext);
  if (!context) {
    throw new Error('useConsole must be used within a ConsoleProvider');
  }
  return context;
}
